package demos.`fun`

import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateIntAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.focusable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.LocalTextStyle
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.roundToInt


const val WORDLE_ANDROID = "d3c6d06a5a31f6fb45039387fb4f764cfffdcc9e567e0e99fac68ffccfca03bb"


class WordleViewModel(

) {

    companion object {
        const val TOTAL_GUESSES = 6
    }

    private val shuffledWords = words.shuffled()

    private var currentWordIndex by mutableStateOf(0)
    val currentWord by derivedStateOf { shuffledWords[currentWordIndex] }

    var currentGuessIndex by mutableStateOf(0)
    val guesses = mutableStateListOf<String>()
    var currentGuess by mutableStateOf("")
        private set

    fun onKey(char: Char) {
        if (currentGuess.length < 5)
            currentGuess += char
    }

    fun onBackSpace() {
        if (currentGuess.isNotBlank())
            currentGuess = currentGuess.take(currentGuess.lastIndex)
    }

    fun onEnter() {
        if (currentGuess.length == 5) {
            guesses.add(currentGuessIndex, currentGuess)
            currentGuess = ""
            currentGuessIndex++
        }
    }

}

private val background = Color(0xffdbd7cc)

@Composable
fun WordleAndroid() {

    val model = remember { WordleViewModel() }
    Box(
        Modifier
            .background(background)
            .fillMaxSize(),
    ) {
        Column(
            Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.SpaceAround,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {

            Text(model.currentWord)

            Guesses(model)
            KeyBoard(
                onKey = model::onKey,
                onBackSpace = model::onBackSpace,
                onEnter = model::onEnter
            )
        }
    }
}

@Composable
fun Guesses(model: WordleViewModel) {
    for (g in 0 until WordleViewModel.TOTAL_GUESSES) {
        val isCurrentGuess = g == model.currentGuessIndex
        val guess = when {
            isCurrentGuess -> model.currentGuess
            else -> model.guesses.getOrNull(g)
        }

        val padding by animateDpAsState(
            targetValue =  if (g == model.currentGuessIndex) 16.dp else 2.dp
        )
        Row(
            horizontalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            for (i in 0 until 5) {
                val isEmpty = guess?.getOrNull(i) == null
                Box(
                    Modifier
                        .shadow(
                            if (isEmpty) 0.dp else 4.dp,
                            shape = RoundedCornerShape(8.dp)
                        )
                        .background(
                            color = background,
                            shape = RoundedCornerShape(8.dp)
                        )
                        .border(
                            width = 1.dp,
                            color = Color.Black.copy(
                                alpha = if (isEmpty) .2f else .8f
                            ),
                            shape = RoundedCornerShape(8.dp)
                        )
                        .padding(
//                            vertical = if (g == model.currentGuessIndex) 16.dp else 2.dp,
                            vertical = padding,
                            horizontal = 16.dp
                        )
                ) {
                    Text(
                        if (isEmpty) "X" else "${guess?.get(i)}",
                        color = Color.Black.copy(alpha = if (isEmpty) .2f else .8f),
                        fontWeight = FontWeight.Light,
                        style = LocalTextStyle.current.copy(
                            fontFeatureSettings = "tnum",
                        )
                    )
                }
            }
        }
    }
}


val qwertz = listOf(
    listOf(
        'Q', 'W', 'E', 'R', 'T', 'Z', 'U', 'I', 'O', 'P'
    ),
    listOf(
        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
    ),
    listOf(
        'Y', 'X', 'C', 'V', 'B', 'N', 'M',
    )
)

val azerty = listOf(
    listOf(
        'A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'
    ),
    listOf(
        'Q', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M',
    ),
    listOf(
        'W', 'X', 'C', 'V', 'B', 'N'
    )
)

val qwerty = listOf(
    listOf(
        'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'
    ),
    listOf(
        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
    ),
    listOf(
        'Z', 'X', 'C', 'V', 'B', 'N', 'M',
    )
)


@Composable
fun KeyBoard(
    onKey: (Char) -> Unit,
    onBackSpace: () -> Unit,
    onEnter: () -> Unit,
) {

    val requester = remember { FocusRequester() }

    var keysPressed by remember { mutableStateOf(setOf<Char>()) }

    Column(
        Modifier
            .onKeyEvent {
                val charPressed = it.key.mapKeyToChar()
                if (charPressed != ' ') {
                    keysPressed = when (it.type) {
                        KeyEventType.KeyDown -> keysPressed.plus(charPressed)

                        else -> {
                            onKey(charPressed)
                            keysPressed.minus(charPressed)
                        }
                    }
                    true
                } else {
                    when (it.type) {
                        KeyEventType.KeyUp -> when (it.key) {
                            Key.Backspace -> {
                                onBackSpace()
                                true
                            }

                            Key.Enter -> {
                                onEnter()
                                true
                            }

                            else -> false
                        }

                        else -> false
                    }
                }
            }.focusRequester(requester)
            .focusable()
            .graphicsLayer {
                transformOrigin = TransformOrigin(.5f, 1f)
                rotationX = 8f
            },
        verticalArrangement = Arrangement.spacedBy(12.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        qwertz.forEach {
            Row(
                horizontalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                it.forEach {
                    Letter(
                        char = it,
                        isKeyPressed = keysPressed.contains(it),
                        onKeyClicked = onKey
                    )
                }
            }
        }
    }

    LaunchedEffect(Unit) {
        requester.requestFocus()
    }
}

@Composable
fun Letter(
    char: Char,
    isKeyPressed: Boolean,
    color: Color = Color(0xff212622),
    onKeyClicked: (Char) -> Unit,
) {

    ModifiedThreeDButtonImpl(
        modifier = Modifier,
        buttonColor = color,
        isKeyboardKeyClicked = isKeyPressed,
        onClick = {
            onKeyClicked(char)
        }
    ) {
        Text(
            "$char",
            color = Color.White,
            fontWeight = FontWeight.Medium,
            style = LocalTextStyle.current.copy(
                fontFeatureSettings = "tnum"
            )
        )
    }


}

fun Char.getKey(): Key {
    return when (this) {
        'A' -> Key.A
        'B' -> Key.B
        'C' -> Key.C
        'D' -> Key.D
        'E' -> Key.E
        'F' -> Key.F
        'G' -> Key.G
        'H' -> Key.H
        'I' -> Key.I
        'J' -> Key.J
        'K' -> Key.K
        'L' -> Key.L
        'M' -> Key.M
        'N' -> Key.N
        'O' -> Key.O
        'P' -> Key.P
        'Q' -> Key.Q
        'R' -> Key.R
        'S' -> Key.S
        'T' -> Key.T
        'U' -> Key.U
        'V' -> Key.V
        'W' -> Key.W
        'X' -> Key.X
        'Y' -> Key.Y
        'Z' -> Key.Z
        else -> Key.ShiftLeft
    }
}

fun Key.mapKeyToChar(): Char {
    return when (this) {
        Key.A -> 'A'
        Key.B -> 'B'
        Key.C -> 'C'
        Key.D -> 'D'
        Key.E -> 'E'
        Key.F -> 'F'
        Key.G -> 'G'
        Key.H -> 'H'
        Key.I -> 'I'
        Key.J -> 'J'
        Key.K -> 'K'
        Key.L -> 'L'
        Key.M -> 'M'
        Key.N -> 'N'
        Key.O -> 'O'
        Key.P -> 'P'
        Key.Q -> 'Q'
        Key.R -> 'R'
        Key.S -> 'S'
        Key.T -> 'T'
        Key.U -> 'U'
        Key.V -> 'V'
        Key.W -> 'W'
        Key.X -> 'X'
        Key.Y -> 'Y'
        Key.Z -> 'Z'
        else -> ' '
    }
}

@Composable
private fun ModifiedThreeDButtonImpl(
    modifier: Modifier = Modifier,
    buttonColor: Color = Color(0xffd736ff),
    isKeyboardKeyClicked: Boolean,
    radius: Dp = 16.dp,
    onClick: () -> Unit,
    content: @Composable RowScope.() -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()

    var isClicked by remember { mutableStateOf(false) }

    val offset by animateIntAsState(
        targetValue = when {
            isClicked || isKeyboardKeyClicked -> 5
            isHovered -> 20
            else -> 15
        },
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy
        )
    )
    Box(
        modifier
            .pointerHoverIcon(PointerIcon.Hand)
            .hoverable(interactionSource)
            .pointerInput(Unit) {
                detectTapGestures(
                    onLongPress = {
                        isClicked = false
                    },
                    onPress = {
                        isClicked = true
                        awaitRelease()
                        onClick()
                        isClicked = false
                    }
                )
            }
            .width(IntrinsicSize.Max)
            .height(IntrinsicSize.Min)
    ) {

        Box(
            Modifier.fillMaxSize()
                .offset { IntOffset(0, (offset * .75f).roundToInt()) }
                .background(
                    Color.Black.copy(alpha = .15f),
                    shape = RoundedCornerShape(radius)
                )
        )

        Box(
            Modifier.fillMaxSize()
                .background(
                    color = buttonColor,
                    shape = RoundedCornerShape(radius)
                )
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color.Transparent,
                            Color.Black.copy(alpha = .3f),
                        ),
                    ),
                    shape = RoundedCornerShape(radius)
                )
        )

        Box(
            Modifier.fillMaxSize()
                .offset { IntOffset(0, -offset) }
                .background(
                    color = buttonColor,
                    shape = RoundedCornerShape(radius)
                )
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(Color.White.copy(alpha = .3f), Color.Transparent)
                    ),
                    shape = RoundedCornerShape(radius)
                )
                .border(
                    width = (1f).dp,
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color.White.copy(alpha = .5f),
                            Color.Transparent,
                            Color.Black.copy(alpha = .1f)
                        )
                    ),
                    shape = RoundedCornerShape(radius)
                )
                .padding(horizontal = 24.dp, vertical = 16.dp)
        ) {
            Row(content = content)
        }
    }
}

val words = listOf(

    // ANDROID VERSIONS
    "froyo",
    "astro",
    "donut",
    "honey",
    "cream",
    "jelly",
    "lolly",
    "oreos",

    // DEVICE CODE NAMES
    "shamu",
    "sojus",
    "mysid",
    "yakju",
    "occam",
    "razor",
    "sargo",
    "flame",
    "coral",
    "raven",

    // DEVICES
    //google
    "pixel",
    "nexus",
    //htc
    "dream",
    "magic",
    "droid",
    "merge",
    "salsa",
    "amaze",
    "rhyme",
    "first",
    "remix",
    //huawei
    "honor",
    "holly",
    "ideos",
    "sonic",
    "youth",
    "enjoy",
    //leica
    "leica",
    "leitz",
    //lenovo
    "turbo",
    //LG
    "thinq",
    "alpha",
    //meizu
    "meizu",
    //motorola
    "charm",
    "atrix",
    "force",
    "power",
    "hyper",
    //nextbit
    "robin",
    //nokia
    "nokia",
    //nubia
    "nubia",
    //pepsi,
    "pepsi",
    //realme
    "narzo",
    "flash",
    "prime",
    //xiaomi
    "redmi",
    "speed",
    //tecno
    "tecno",
    "camon",
    "spark",
    //zte
    "racer",
    "blade",
    "libra",
    "skate",
    "score",
    "avail",
    "grand",
    //samsung
    "ultra",


    // COMMON TERMS
    "phone",
    "mouse",
    "point",
    "panel",
    "shape",
    "field",
    "black",
    "white",
    "metal",
    "cloud",
    "hello",
    "world",


    // ANDROID DEV TERMS
    "asset",
    "build",
    "theme",
    "event",
    "image",
    "color",
    "frame",
    "print",
    "style",
    "bazel",
    "start",
    "toast",
    "state",
    "crash",
    "debug",
    "clean",
    "proxy",
    "share",
    "float",
    "route",
    "error",
    "swipe",
    "fetch",
    "model",
    "glide",
    "smart",
    "async",
    "light",
    "cache",
    "scope",
    "maven",


    )